{
    "Page_Title": "Ações do administrador",
    "Action_Label_MC": "Fazer chamada",
    "Action_Label_MCC": "Consulta telefônica",
    "Action_Label_MDT": "Discagem de tom DTMF",
    "Action_Label_CC": "Limpar chamada (via controle de chamadas)",
    "Action_Label_CCCM": "Clear Call (Via Modelo de Chamada)",
    "Action_Label_CX": "Conexão clara",
    "Action_Label_AC": "Atender chamada",
    "Action_Label_HD": "Chamada em espera",
    "Action_Label_PC": "Park Call",
    "Action_Label_RC": "Recuperar chamada",
    "Action_Label_ATC": "Chamada alternativa",
    "Action_Label_PUC": "Chamada de coleta",
    "Action_Label_TO": "Transferência em um passo",
    "Action_Label_TR": "Transferência concluída",
    "Action_Label_DF": "Desviar\/Refutar Chamada",
    "Action_Label_MONC": "Conexão do monitor",
    "Action_Label_REC": "Gravar chamada",
    "Action_Label_CBMSG": "Registre o retorno de chamada",
    "Action_Label_CO": "Participe da Conferência",
    "Action_Label_MES": "Iniciar o monitor",
    "Action_Label_MEP": "Parar o monitor",
    "Action_Label_SDND": "Definir status do DNS",
    "Action_Label_SACD": "Definir status ACD",
    "Action_Label_SFWD": "Definir status de encaminhamento",
    "Action_Label_SACC": "Definir código da conta",
    "Action_Label_SPWD": "Definir senha da entidade",
    "Action_Label_QDND": "Consultar o status de Não Perturbe",
    "Action_Label_QACD": "Consultar o status do ACD",
    "Action_Label_QFWD": "Status de encaminhamento da consulta",
    "Action_Label_SPC": "Chamada instantânea",
    "Action_Label_SPD": "Dispositivo de captura de instantâneo",
    "AcdOption_SignIn": "Entrar",
    "AcdOption_SignOut": "Sair",
    "AcdOption_Available": "Disponível",
    "AcdOption_NotAvailable": "Não disponível",
    "AcdOption_AlertingAcd": "Alerta (ACD)",
    "AcdOption_AlertingNonAcd": "Alerta (Não ACD)",
    "AcdOption_BusyAcd": "Ocupado (ACD)",
    "AcdOption_BusyNonAcd": "Ocupado (Não ACD)",
    "AcdOption_BusySupervisor": "Ocupado (Supervisor)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Conclusão",
    "ForwardOption_None": "Nenhum",
    "ForwardOption_Immediate": "Imediato",
    "ForwardOption_OnBusy": "Em movimento",
    "ForwardOption_NoAnswer": "Sem resposta",
    "ForwardOption_OnDnd": "Sobre o DND",
    "ForwardOption_OnOos": "Em OOS",
    "Field_Label_DeviceMain": "Dispositivo",
    "Field_Label_Destination": "Destino",
    "Field_Label_CallIDMain": "ID de chamada ativo",
    "Field_Label_DestinationAutoPrefix": "Prefixo de destino automático?",
    "Field_Label_CallIDHeld": "Outro ID de chamada",
    "Field_Label_DTMFTones": "Tons DTMF",
    "Field_Label_ParkLocation": "Localização do parque",
    "Field_Label_OtherCallID": "Outro ID de chamada",
    "Field_Label_DeviceToPickupAt": "Dispositivo para retirada em",
    "Field_Label_CallParked": "Chamada estacionada",
    "Field_Label_MonitorType": "Tipo de monitor",
    "Field_Label_Password": "Senha",
    "Field_Label_UseSecurePassword": "Usar senha segura?",
    "Field_Label_MonitorCrossRefID": "ID de referência cruzada do monitor",
    "Field_Label_IsDND": "Ativar\/Desativar o modo Não Perturbe",
    "Field_Label_AgentID": "ID do agente",
    "Field_Label_ACDGroup": "Grupo ACD",
    "Field_Label_ACDStateReasonTextID": "ID do texto ACDStateReason",
    "Field_Label_ACDStatus": "Status ACD",
    "Field_Label_ForwardMode": "Status de encaminhamento",
    "Field_Label_AccountCode": "Código da conta",
    "Field_Label_PasswordOld": "Senha Antiga",
    "Field_Label_PasswordNew": "Nova Senha",
    "Field_Label_TelephonyServer": "Servidor de telefonia",
    "Field_Label_Partition": "Partição",
    "Field_Label_CME": "Educação Médica Continuada",
    "Action_Button_Label_Execute": "Executar",
    "Action_Button_Label_Reset": "Reiniciar",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Ação",
    "Action_Label_GUC": "Obtenha a Política de Conformidade do Usuário",
    "Action_Label_AAP": "Aplicar a Política de Captura da Akixi",
    "Action_Label_QPS": "Consultar o estado de presença",
    "Action_Label_DUP": "Política de Exclusão de Usuário",
    "Action_Label_GT": "Contratar inquilino",
    "Action_Label_DT": "Excluir locatário",
    "Action_Label_GU": "Obter usuários",
    "Action_Label_GVA": "Obtenha aplicativos de voz",
    "Field_Label_SilentMonitor": "Monitor silencioso",
    "Field_Label_ForcedIntrude": "Intrusão forçada",
    "Field_Label_Policies": "Políticas"
}